import WPhoto_SloppyPhotoComponent from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/skinComps/SloppyPhoto/SloppyPhoto.skin';
import WPhoto_SloppyPhotoController from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/WPhoto.controller';


const WPhoto_SloppyPhoto = {
  component: WPhoto_SloppyPhotoComponent,
  controller: WPhoto_SloppyPhotoController
};


export const components = {
  ['WPhoto_SloppyPhoto']: WPhoto_SloppyPhoto
};

